import { Serializer } from 'jsonapi-serializer';
import { Notification } from '../interfaces/notification.interface';
import { uuidv7 } from 'uuidv7';

const serializer = new Serializer('Notification', {
	id: 'id',
	keyForAttribute: (attr: string) => attr,
	pluralizeType: false,
	attributes: ['active_start_at', 'active_end_at', 'apps', 'content', 'roles', 'title'],
	transform(record: any) {
		return {
			id: record.id ?? uuidv7(),
			...record,
		};
	},
});

export function serializeNotification(notification: Notification) {
	return serializer.serialize(notification);
}
